module.exports = __webpack_public_path__ + "6f5a51117e3f54bcd197042ef7b21ced.svg";